const { MAX_SAFE_INTEGER = 9007199254740991 } = Number;

/**
 * Make sure the input is a number and is a positive integer.
 */
export function numberify(input: any): number {
    if (typeof input !== "number") {
        return;
    }

    const value = Number.parseFloat(input.toString());

    if (Number.isNaN(value)) {
        return;
    }

    if (value < 0) {
        return;
    }

    if (!Number.isFinite(value)) {
        return;
    }

    if (value > MAX_SAFE_INTEGER) {
        return MAX_SAFE_INTEGER;
    }

    return value;
}
